import React from 'react';
import "bootstrap/dist/css/bootstrap.css";
import '../../assets/css/style.css';

import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Redirect, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import * as api from '../../api/api';

class CustomContentFileInfoPage extends React.Component {
    constructor(props) {
        super(props);

        let returnUrl = new URLSearchParams(this.props.location.search).get("return_url");

        this.state = {
            data: {},
            returnUrl: returnUrl,
            needRedirect: false
        };

        this.props.updateLoader({
            loaded: false,
            message: ""
        });

        // this.fileInput = React.createRef();
    }

    componentDidMount() {

        if (!api.isUserAdmin()) {
            this.setState({
                returnUrl: "/users/permission-denied",
                needRedirect: true
            });

            return;
        }

        if (this.props.match.params.id != 0) {
            api.makeRequest(api.getCustomContentFileDetails(this.props.match.params.id)).then(
                (getDataResponse) => {

                    this.setState({
                        data: getDataResponse.data.data
                    });

                    this.props.updateLoader({
                        loaded: true
                    });
                },
                (error) => {
                    this.props.updateLoader({
                        loaded: true,
                        message: "Ошибка при получении данных: " + error
                    });

                    this.setState({
                        data: null,
                    });
                }
            );
        } else {
            this.setState({
                data: {
                    id: 0,
                    name: '',
                    description: '',
                    fileName: ''
                }
            });

            this.props.updateLoader({
                loaded: true
            });
        }
    }

    // save(data) {

    //     this.props.updateLoader({
    //         loaded: false
    //     });

    //     api.makeRequest(api.saveCustomContentFile(data.file)).then(
    //         (response) => {

    //             this.props.updateLoader({
    //                 loaded: true
    //             });

    //             this.setState({
    //                 needRedirect: true
    //             });
    //         },
    //         (error) => {
    //             this.props.updateLoader({
    //                 loaded: true,
    //                 message: "Ошибка при сохранении: " + error
    //             });
    //         }
    //     )
    //         .catch((error) => {
    //             this.props.updateLoader({
    //                 loaded: true,
    //                 message: "Ошибка при сохранении: " + error
    //             });
    //         });
    // }

    save(formikData) {

        const data = new FormData() 
        data.append('file', formikData.file);

        this.props.updateLoader({
            loaded: false
        });

        api.makeRequest(api.saveCustomContentFile(data)).then(
            (response) => {

                this.props.updateLoader({
                    loaded: true
                });

                this.setState({
                    needRedirect: true
                });
            },
            (error) => {
                this.props.updateLoader({
                    loaded: true,
                    message: "Ошибка при сохранении: " + error
                });
            }
        )
            .catch((error) => {
                this.props.updateLoader({
                    loaded: true,
                    message: "Ошибка при сохранении: " + error
                });
            });
    }

    render() {

        if (this.state.needRedirect) {
            return <Redirect to={this.state.returnUrl} />
        }

        return (
            <div>

                <h4 className="mb-4">{this.props.match.params.id == 0 ? "Регистрация нового файла" : "Редактирование информации о файле"}</h4>

                <Formik
                    initialValues={this.state.data}
                    //TODO: поправить
                    enableReinitialize={true}
                    //
                    validate={values => {
                        let errors = {};
                        if (!values.name) {
                            errors.name = 'Пожалуйста, заполните это поле';
                        };

                        if (!values.description) {
                            errors.description = 'Пожалуйста, заполните это поле';
                        };

                        // if (!values.fileName) {
                        //     errors.fileName = 'Пожалуйста, заполните это поле';
                        // };

                        return errors;
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        this.save(values);
                    }}
                >
                    {({
                        setFieldValue
                    }) => (
                            <Form className="">
                                <div className="form-group">
                                    <label>Название</label>
                                    <Field className="form-control" type="text" name="name" />
                                    <ErrorMessage className="form-error-message" name="name" component="div" />
                                </div>
                                <div className="form-group">
                                    <label>Описание</label>
                                    <Field className="form-control" type="text" name="description" />
                                    <ErrorMessage className="form-error-message" name="description" component="div" />
                                </div>
                                {/* <div className="form-group">
                                <label>Имя файла</label>
                                <Field className="form-control" type="text" name="fileName" />
                                <ErrorMessage className="form-error-message" name="fileName" component="div" />
                            </div> */}
                                <div className="form-group">
                                    <label>Файл</label>
                                    <input 
                                        type="file"
                                        onChange={(event) => this.setState({ file: event.currentTarget.files[0] })}
                                    />
                                    <ErrorMessage className="form-error-message" name="description" component="div" />
                                </div>
                                <button className="btn btn-primary-custom" type="submit">
                                    Сохранить
                            </button>
                                <button className="btn btn-secondary ml-2 btn-with-link" type="button">
                                    <Link to={this.state.returnUrl}>Назад</Link>
                                </button>
                            </Form>
                        )}
                </Formik>
            </div>
        );
    }
}

export default CustomContentFileInfoPage;